export type ApprovalTargetConfig = {
  sla_hours?: unknown;
  due_in_hours?: unknown;
};

/** Runtime twin: Backend engine prefers sla_hours, then legacy due_in_hours. */
export function approvalTargetHours(
  config: ApprovalTargetConfig | null | undefined,
): number | null {
  const raw = config?.sla_hours ?? config?.due_in_hours;
  if (typeof raw !== 'number' || !Number.isFinite(raw) || raw <= 0) return null;
  return raw;
}

export function formatApprovalTargetHours(hours: number, locale: string): string {
  const useDays = hours >= 24;
  const value = useDays ? hours / 24 : hours;
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    style: 'unit',
    unit: useDays ? 'day' : 'hour',
    unitDisplay: 'long',
  }).format(value);
}
